/* tslint:disable */
/* eslint-disable */
/**
 * Veritable
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 7.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ActivityLogPatch } from '../models';
// @ts-ignore
import type { ActivityLogPost } from '../models';
// @ts-ignore
import type { ActivityLogQueryModel } from '../models';
// @ts-ignore
import type { GetActivityLogs200Response } from '../models';
// @ts-ignore
import type { HTTPValidationError } from '../models';
// @ts-ignore
import type { WorklistEntityType } from '../models';
/**
 * ActivityLogApi - axios parameter creator
 * @export
 */
export const ActivityLogApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a new activity log for an entity type
         * @summary Create a new activity log for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {ActivityLogPost} activityLogPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLog: async (entityType: WorklistEntityType, entityId: string, activityLogPost: ActivityLogPost, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('createActivityLog', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('createActivityLog', 'entityId', entityId)
            // verify required parameter 'activityLogPost' is not null or undefined
            assertParamExists('createActivityLog', 'activityLogPost', activityLogPost)
            const localVarPath = `/api/v1/fhir/activityLog/{entityType}/{entityId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityLogPost, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an activity log for an entity type
         * @summary Delete an activity log for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {string} activityLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityLog: async (entityType: WorklistEntityType, entityId: string, activityLogId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('deleteActivityLog', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('deleteActivityLog', 'entityId', entityId)
            // verify required parameter 'activityLogId' is not null or undefined
            assertParamExists('deleteActivityLog', 'activityLogId', activityLogId)
            const localVarPath = `/api/v1/fhir/activityLog/{entityType}/{entityId}/{activityLogId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"activityLogId"}}`, encodeURIComponent(String(activityLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get all activity logs for an entity type
         * @summary Get all activity logs for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {ActivityLogQueryModel} activityLogQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogs: async (entityType: WorklistEntityType, entityId: string, activityLogQueryModel: ActivityLogQueryModel, pgNum?: number, pgSize?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('getActivityLogs', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('getActivityLogs', 'entityId', entityId)
            // verify required parameter 'activityLogQueryModel' is not null or undefined
            assertParamExists('getActivityLogs', 'activityLogQueryModel', activityLogQueryModel)
            const localVarPath = `/api/v1/fhir/activityLog/{entityType}/{entityId}/search`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)

            if (pgNum !== undefined) {
                localVarQueryParameter['pg_num'] = pgNum;
            }

            if (pgSize !== undefined) {
                localVarQueryParameter['pg_size'] = pgSize;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityLogQueryModel, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an activity log for an entity type
         * @summary Update an activity log for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {string} activityLogId 
         * @param {ActivityLogPatch} activityLogPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivityLog: async (entityType: WorklistEntityType, entityId: string, activityLogId: string, activityLogPatch: ActivityLogPatch, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'entityType' is not null or undefined
            assertParamExists('updateActivityLog', 'entityType', entityType)
            // verify required parameter 'entityId' is not null or undefined
            assertParamExists('updateActivityLog', 'entityId', entityId)
            // verify required parameter 'activityLogId' is not null or undefined
            assertParamExists('updateActivityLog', 'activityLogId', activityLogId)
            // verify required parameter 'activityLogPatch' is not null or undefined
            assertParamExists('updateActivityLog', 'activityLogPatch', activityLogPatch)
            const localVarPath = `/api/v1/fhir/activityLog/{entityType}/{entityId}/{activityLogId}`
                .replace(`{${"entityType"}}`, encodeURIComponent(String(entityType)))
                .replace(`{${"entityId"}}`, encodeURIComponent(String(entityId)))
                .replace(`{${"activityLogId"}}`, encodeURIComponent(String(activityLogId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication OAuth2Auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "OAuth2Auth", ["email", "profile", "openid"], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(activityLogPatch, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ActivityLogApi - functional programming interface
 * @export
 */
export const ActivityLogApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ActivityLogApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a new activity log for an entity type
         * @summary Create a new activity log for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {ActivityLogPost} activityLogPost 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createActivityLog(entityType: WorklistEntityType, entityId: string, activityLogPost: ActivityLogPost, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createActivityLog(entityType, entityId, activityLogPost, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.createActivityLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an activity log for an entity type
         * @summary Delete an activity log for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {string} activityLogId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteActivityLog(entityType: WorklistEntityType, entityId: string, activityLogId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteActivityLog(entityType, entityId, activityLogId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.deleteActivityLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get all activity logs for an entity type
         * @summary Get all activity logs for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {ActivityLogQueryModel} activityLogQueryModel 
         * @param {number} [pgNum] 
         * @param {number} [pgSize] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActivityLogs(entityType: WorklistEntityType, entityId: string, activityLogQueryModel: ActivityLogQueryModel, pgNum?: number, pgSize?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetActivityLogs200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActivityLogs(entityType, entityId, activityLogQueryModel, pgNum, pgSize, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.getActivityLogs']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an activity log for an entity type
         * @summary Update an activity log for an entity type
         * @param {WorklistEntityType} entityType 
         * @param {string} entityId 
         * @param {string} activityLogId 
         * @param {ActivityLogPatch} activityLogPatch 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateActivityLog(entityType: WorklistEntityType, entityId: string, activityLogId: string, activityLogPatch: ActivityLogPatch, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateActivityLog(entityType, entityId, activityLogId, activityLogPatch, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ActivityLogApi.updateActivityLog']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ActivityLogApi - factory interface
 * @export
 */
export const ActivityLogApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ActivityLogApiFp(configuration)
    return {
        /**
         * Create a new activity log for an entity type
         * @summary Create a new activity log for an entity type
         * @param {ActivityLogApiCreateActivityLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createActivityLog(requestParameters: ActivityLogApiCreateActivityLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.createActivityLog(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogPost, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an activity log for an entity type
         * @summary Delete an activity log for an entity type
         * @param {ActivityLogApiDeleteActivityLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteActivityLog(requestParameters: ActivityLogApiDeleteActivityLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteActivityLog(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogId, options).then((request) => request(axios, basePath));
        },
        /**
         * Get all activity logs for an entity type
         * @summary Get all activity logs for an entity type
         * @param {ActivityLogApiGetActivityLogsRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActivityLogs(requestParameters: ActivityLogApiGetActivityLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityLogs200Response> {
            return localVarFp.getActivityLogs(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogQueryModel, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an activity log for an entity type
         * @summary Update an activity log for an entity type
         * @param {ActivityLogApiUpdateActivityLogRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateActivityLog(requestParameters: ActivityLogApiUpdateActivityLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.updateActivityLog(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogId, requestParameters.activityLogPatch, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ActivityLogApi - interface
 * @export
 * @interface ActivityLogApi
 */
export interface ActivityLogApiInterface {
    /**
     * Create a new activity log for an entity type
     * @summary Create a new activity log for an entity type
     * @param {ActivityLogApiCreateActivityLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApiInterface
     */
    createActivityLog(requestParameters: ActivityLogApiCreateActivityLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Delete an activity log for an entity type
     * @summary Delete an activity log for an entity type
     * @param {ActivityLogApiDeleteActivityLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApiInterface
     */
    deleteActivityLog(requestParameters: ActivityLogApiDeleteActivityLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Get all activity logs for an entity type
     * @summary Get all activity logs for an entity type
     * @param {ActivityLogApiGetActivityLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApiInterface
     */
    getActivityLogs(requestParameters: ActivityLogApiGetActivityLogsRequest, options?: RawAxiosRequestConfig): AxiosPromise<GetActivityLogs200Response>;

    /**
     * Update an activity log for an entity type
     * @summary Update an activity log for an entity type
     * @param {ActivityLogApiUpdateActivityLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApiInterface
     */
    updateActivityLog(requestParameters: ActivityLogApiUpdateActivityLogRequest, options?: RawAxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for createActivityLog operation in ActivityLogApi.
 * @export
 * @interface ActivityLogApiCreateActivityLogRequest
 */
export interface ActivityLogApiCreateActivityLogRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityLogApiCreateActivityLog
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof ActivityLogApiCreateActivityLog
     */
    readonly entityId: string

    /**
     * 
     * @type {ActivityLogPost}
     * @memberof ActivityLogApiCreateActivityLog
     */
    readonly activityLogPost: ActivityLogPost
}

/**
 * Request parameters for deleteActivityLog operation in ActivityLogApi.
 * @export
 * @interface ActivityLogApiDeleteActivityLogRequest
 */
export interface ActivityLogApiDeleteActivityLogRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityLogApiDeleteActivityLog
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof ActivityLogApiDeleteActivityLog
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof ActivityLogApiDeleteActivityLog
     */
    readonly activityLogId: string
}

/**
 * Request parameters for getActivityLogs operation in ActivityLogApi.
 * @export
 * @interface ActivityLogApiGetActivityLogsRequest
 */
export interface ActivityLogApiGetActivityLogsRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityLogApiGetActivityLogs
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof ActivityLogApiGetActivityLogs
     */
    readonly entityId: string

    /**
     * 
     * @type {ActivityLogQueryModel}
     * @memberof ActivityLogApiGetActivityLogs
     */
    readonly activityLogQueryModel: ActivityLogQueryModel

    /**
     * 
     * @type {number}
     * @memberof ActivityLogApiGetActivityLogs
     */
    readonly pgNum?: number

    /**
     * 
     * @type {number}
     * @memberof ActivityLogApiGetActivityLogs
     */
    readonly pgSize?: number
}

/**
 * Request parameters for updateActivityLog operation in ActivityLogApi.
 * @export
 * @interface ActivityLogApiUpdateActivityLogRequest
 */
export interface ActivityLogApiUpdateActivityLogRequest {
    /**
     * 
     * @type {WorklistEntityType}
     * @memberof ActivityLogApiUpdateActivityLog
     */
    readonly entityType: WorklistEntityType

    /**
     * 
     * @type {string}
     * @memberof ActivityLogApiUpdateActivityLog
     */
    readonly entityId: string

    /**
     * 
     * @type {string}
     * @memberof ActivityLogApiUpdateActivityLog
     */
    readonly activityLogId: string

    /**
     * 
     * @type {ActivityLogPatch}
     * @memberof ActivityLogApiUpdateActivityLog
     */
    readonly activityLogPatch: ActivityLogPatch
}

/**
 * ActivityLogApi - object-oriented interface
 * @export
 * @class ActivityLogApi
 * @extends {BaseAPI}
 */
export class ActivityLogApi extends BaseAPI implements ActivityLogApiInterface {
    /**
     * Create a new activity log for an entity type
     * @summary Create a new activity log for an entity type
     * @param {ActivityLogApiCreateActivityLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public createActivityLog(requestParameters: ActivityLogApiCreateActivityLogRequest, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).createActivityLog(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogPost, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an activity log for an entity type
     * @summary Delete an activity log for an entity type
     * @param {ActivityLogApiDeleteActivityLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public deleteActivityLog(requestParameters: ActivityLogApiDeleteActivityLogRequest, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).deleteActivityLog(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get all activity logs for an entity type
     * @summary Get all activity logs for an entity type
     * @param {ActivityLogApiGetActivityLogsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public getActivityLogs(requestParameters: ActivityLogApiGetActivityLogsRequest, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).getActivityLogs(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogQueryModel, requestParameters.pgNum, requestParameters.pgSize, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an activity log for an entity type
     * @summary Update an activity log for an entity type
     * @param {ActivityLogApiUpdateActivityLogRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ActivityLogApi
     */
    public updateActivityLog(requestParameters: ActivityLogApiUpdateActivityLogRequest, options?: RawAxiosRequestConfig) {
        return ActivityLogApiFp(this.configuration).updateActivityLog(requestParameters.entityType, requestParameters.entityId, requestParameters.activityLogId, requestParameters.activityLogPatch, options).then((request) => request(this.axios, this.basePath));
    }
}

